import type { FC } from 'react';

import { ChatProvider } from '@apps/chat-shared-multilabel/ChatProvider';
import { clearLocalSession } from '@apps/myzone-be-eneco/utils/auth/logout';
import { registerSignOutCleanup, SessionExpiryHandler } from '@eneco/auth';
import { Locale } from '@eneco/common/application';
import type { AppProps } from '@eneco/next';
import { NEXT_LOCALE_COOKIE } from '@eneco/next/constants';
import { SparkyProvider } from '@eneco/sparky/providers';
import Cookies from 'js-cookie';
import { SessionProvider } from 'next-auth/react';

import { seamlyConfig } from '../config';

registerSignOutCleanup(clearLocalSession);

const MainApp: FC<AppProps> = ({ Component, pageProps: { session, ...pageProps }, router }) => {
  const locale = Cookies.get(NEXT_LOCALE_COOKIE) ?? 'nl';
  const path = router.asPath;
  const segment = path.split('/')[1];
  const chatbotTopic = pageProps.layoutData?.sitecore?.route?.fields?.chatBotTopicText?.value;
  let sparkyLocale: Locale = 'nl-BE';

  if (segment === 'business' || segment === 'b2b' || segment === 'entreprises') {
    seamlyConfig.defaultNamespace = 'b2b-be';
  }

  if (locale === 'fr') {
    seamlyConfig.defaultLocale = 'fr';
    seamlyConfig.userLocale = 'fr';
    sparkyLocale = 'fr-BE';
  }

  // There is no German chatbot so we will use the French one and automatically translate it to German
  if (locale === 'de') {
    seamlyConfig.defaultLocale = 'fr';
    seamlyConfig.userLocale = 'de-informal';
    sparkyLocale = 'fr-BE';
  }

  if (chatbotTopic && chatbotTopic !== '') {
    seamlyConfig.defaultTopic = chatbotTopic;
  }

  if (pageProps.selectedAccount?.crmAccountNumber && pageProps.selectedAccount?.crmAccountNumber !== '') {
    seamlyConfig.accountId = pageProps.selectedAccount.crmAccountNumber;
  }

  return (
    <SessionProvider session={session} basePath={`${router.basePath}/api/auth`}>
      <SessionExpiryHandler />
      <SparkyProvider locale={sparkyLocale}>
        <ChatProvider config={seamlyConfig}>
          <Component {...pageProps} />
        </ChatProvider>
      </SparkyProvider>
    </SessionProvider>
  );
};

export default MainApp;
